import { Col, Container } from "react-bootstrap";
import SectionHeading from "../ui/SectionHeading";
import { RevealGroup, RevealItem } from "../ui/Reveal";
import "../style/ProductsShowcase.css";

const PRODUCTS = [
  {
    image: "/images/dishes/idlybatter.png",
    name: "Idly Batter",
    text: "Soft, pillowy idlis every time — no soda, no shortcuts.",
  },
  {
    image: "/images/dishes/dosabatter.png",
    name: "Dosa Batter",
    text: "Thin, golden and crisp on a hot tawa in minutes.",
  },
  {
    image: "/images/dishes/ragibatter.png",
    name: "Ragi Batter",
    text: "A finger-millet dosa with a nutty bite and real nutrition.",
  },
  {
    image: "/images/urad2.jpg",
    name: "Multi-grain Batter",
    text: "Our newest blend — several grains, one wholesome batter.",
  },
];

const ProductsShowcase = () => {
  return (
    <section className="section-pad products-showcase">
      <Container className="container-narrow">
        <SectionHeading
          eyebrow="Our Batter"
          title="Four Batters, One Promise"
          subtitle="Ready to cook, straight from the pack. Pick what your family is craving today."
        />
        <RevealGroup className="row g-4">
          {PRODUCTS.map(({ image, name, text }, i) => (
            <Col sm={6} lg={3} key={name}>
              <RevealItem delay={i * 80} className="products-showcase__card card-surface">
                <img src={image} alt={name} className="products-showcase__img" />
                <div className="products-showcase__body">
                  <h3>{name}</h3>
                  <p>{text}</p>
                </div>
              </RevealItem>
            </Col>
          ))}
        </RevealGroup>
      </Container>
    </section>
  );
};

export default ProductsShowcase;
